/* import __COLOCATED_TEMPLATE__ from './editor-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import type ContentImportService from 'embercom/services/content-import-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class EditorEmptyState extends Component {
  @service declare contentImportService: ContentImportService;
  @service declare appService: $TSFixMe;
  @service declare finStandaloneService: FinStandaloneService;

  @tracked showZendeskConnectDrawer = false;
  @tracked showSalesforceConnectDrawer = false;

  get contentReviewSummary() {
    return this.contentImportService.aiContentReviewSummary;
  }

  get hasApprovedSuggestions() {
    if (!this.contentReviewSummary) {
      return false;
    }
    return this.contentReviewSummary.approved > 0;
  }

  get shouldShowZendeskConnectScreen() {
    return (
      this.appService.app.isStandaloneApp &&
      this.finStandaloneService.zendeskPlatformConvSyncingNotEnabled
    );
  }

  get shouldShowSalesforceConnectScreen() {
    return (
      this.appService.app.isStandaloneApp &&
      this.finStandaloneService.salesforcePlatformConvSyncingNotEnabled
    );
  }

  @action
  closeZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = false;
  }

  @action
  openZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = true;
  }

  @action
  openSalesforceConnectDrawer() {
    this.showSalesforceConnectDrawer = true;
  }

  @action
  closeSalesforceConnectDrawer() {
    this.showSalesforceConnectDrawer = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::EditorEmptyState': typeof EditorEmptyState;
  }
}
